<template>
  <div>
    <b-card :title="$t('general.titleHomePage')">
      <b-card-text>{{ $t('general.welcomeHomePage') }}</b-card-text>
    </b-card>

    <!--    <b-card title="Want to integrate JWT? 🔒">-->
    <!--      <b-card-text>We carefully crafted JWT flow so you can implement JWT with ease and with minimum efforts.</b-card-text>-->
    <!--      <b-card-text>Please read our  JWT Documentation to get more out of JWT authentication.</b-card-text>-->
    <!--    </b-card>-->
  </div>
</template>

<script>
import {BCard, BCardText, BLink} from 'bootstrap-vue';
export default {
  components: {
    BCard,
    BCardText,
    BLink,
  },
//   beforeRouteEnter(to, from, next) {
//     // console.log('testtt',from);
//   // next(vm => vm.previousRoute = from);
// },
  mounted(){
    // if (this.$route.path == 'login') {
      
    // }
  },
  created() {
  this.setBreadcrumbs([{text: 'homePage', translate:true, to:{name:'home'}}])
    this.setCurrentBreadcrumb([{text: 'homePage', translate:true, to:{name:'home'}}])

  }
}
</script>

<style>

</style>
